const C = { r: '#b0413e', g: '#2f6d4f', b: '#35548f', ink: '#232c3a' }
const FACE = '#f9f6ee'
const EDGE = '#cfc6b4'
const FONT = "'Hiragino Mincho ProN','Yu Mincho','Noto Serif JP','MS Mincho',serif"
const NUM = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九']
const PIN = {
  1: [[30, 42, 15]],
  2: [[30, 23, 10], [30, 61, 10]],
  3: [[16, 19, 8.5], [30, 42, 8.5], [44, 65, 8.5]],
  4: [[18, 23, 8.5], [42, 23, 8.5], [18, 61, 8.5], [42, 61, 8.5]],
  5: [[17, 21, 8], [43, 21, 8], [30, 42, 8], [17, 63, 8], [43, 63, 8]],
  6: [[18, 20, 7.5], [42, 20, 7.5], [18, 42, 7.5], [42, 42, 7.5], [18, 64, 7.5], [42, 64, 7.5]],
  7: [[13, 15, 7], [28, 19, 7], [43, 23, 7], [18, 45, 7], [42, 45, 7], [18, 66, 7], [42, 66, 7]],
  8: [[18, 14, 7], [42, 14, 7], [18, 33, 7], [42, 33, 7], [18, 52, 7], [42, 52, 7], [18, 71, 7], [42, 71, 7]],
  9: [[16, 19, 7], [30, 19, 7], [44, 19, 7], [16, 42, 7], [30, 42, 7], [44, 42, 7], [16, 65, 7], [30, 65, 7], [44, 65, 7]],
}
const PINC = {
  1: [C.r], 2: [C.b, C.b], 3: [C.b, C.r, C.g], 4: [C.b, C.g, C.g, C.b],
  5: [C.b, C.g, C.r, C.g, C.b], 6: [C.g, C.g, C.r, C.r, C.r, C.r],
  7: [C.g, C.g, C.g, C.r, C.r, C.r, C.r], 8: [C.b, C.b, C.b, C.b, C.b, C.b, C.b, C.b],
  9: [C.b, C.b, C.b, C.r, C.r, C.r, C.g, C.g, C.g],
}
const SOU = {
  2: [[30, 23], [30, 61]], 3: [[30, 20], [18, 62], [42, 62]],
  4: [[18, 23], [42, 23], [18, 61], [42, 61]],
  5: [[18, 21], [42, 21], [30, 42], [18, 63], [42, 63]],
  6: [[18, 23], [30, 23], [42, 23], [18, 61], [30, 61], [42, 61]],
  7: [[30, 17], [18, 44], [30, 44], [42, 44], [18, 69], [30, 69], [42, 69]],
  8: [[12, 23], [24, 23], [36, 23], [48, 23], [12, 61], [24, 61], [36, 61], [48, 61]],
  9: [[16, 19], [30, 19], [44, 19], [16, 42], [30, 42], [44, 42], [16, 65], [30, 65], [44, 65]],
}
const SH = { 2: 30, 3: 26, 4: 24, 5: 20, 6: 24, 7: 18, 8: 18, 9: 17 }

function circ(x, y, r, col) {
  return "<circle cx='" + x + "' cy='" + y + "' r='" + r + "' fill='" + col + "'/><circle cx='" + x + "' cy='" + y + "' r='" + (r * 0.58).toFixed(2) + "' fill='" + FACE + "'/><circle cx='" + x + "' cy='" + y + "' r='" + (r * 0.26).toFixed(2) + "' fill='" + col + "'/>"
}

function stick(x, y, h, col) {
  const w = Math.max(4.6, h * 0.32)
  return "<rect x='" + (x - w / 2).toFixed(2) + "' y='" + (y - h / 2).toFixed(2) + "' width='" + w.toFixed(2) + "' height='" + h + "' rx='" + (w / 2).toFixed(2) + "' fill='" + col + "'/><rect x='" + (x - w / 2).toFixed(2) + "' y='" + (y - 1) + "' width='" + w.toFixed(2) + "' height='2' fill='" + FACE + "' opacity='0.9'/>"
}

function faceOf(code) {
  const n = +code[0]
  const s = code[1]
  const aka = n === 0
  const num = aka ? 5 : n
  if (s === 'm') {
    return "<text x='30' y='38' font-size='30' font-weight='700' text-anchor='middle' font-family=\"" + FONT + "\" fill='" + (aka ? C.r : C.ink) + "'>" + NUM[num] + "</text><text x='30' y='73' font-size='29' font-weight='700' text-anchor='middle' font-family=\"" + FONT + "\" fill='" + C.r + "'>萬</text>"
  }
  if (s === 'p') {
    const cols = aka ? PIN[num].map(() => C.r) : PINC[num]
    return PIN[num].map((p, k) => circ(p[0], p[1], p[2], cols[k])).join('')
  }
  if (s === 's') {
    if (num === 1) return stick(30, 42, 40, aka ? C.r : C.g) + "<rect x='24.5' y='29' width='11' height='4' rx='2' fill='" + C.r + "'/><rect x='24.5' y='51' width='11' height='4' rx='2' fill='" + C.r + "'/>"
    const h = SH[num]
    return SOU[num].map((p, k) => {
      const col = aka ? C.r : ((num === 5 && k === 2) ? C.r : C.g)
      return stick(p[0], p[1], h, col)
    }).join('')
  }
  if (s === 'z') {
    if (num === 5) return "<rect x='11' y='13' width='38' height='58' rx='4' fill='none' stroke='#8fb0d1' stroke-width='2.5'/>"
    const ch = ['', '東', '南', '西', '北', '', '發', '中'][num]
    const col = num < 5 ? C.ink : (num === 6 ? C.g : C.r)
    return "<text x='30' y='56' font-size='42' font-weight='700' text-anchor='middle' font-family=\"" + FONT + "\" fill='" + col + "'>" + ch + "</text>"
  }
  return ''
}

const BACK = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 84'><rect x='0.75' y='0.75' width='58.5' height='82.5' rx='7' fill='#4a6a97' stroke='#38547c' stroke-width='1.5'/><rect x='7' y='7' width='46' height='70' rx='5' fill='none' stroke='rgba(255,255,255,0.22)' stroke-width='1.5'/></svg>"

const cache = {}

function tileDataURI(code) {
  if (cache[code]) return cache[code]
  const svg = code === 'xx'
    ? BACK
    : "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 84'><rect x='0.75' y='0.75' width='58.5' height='82.5' rx='7' fill='" + (code[0] === '0' ? '#fbeeea' : FACE) + "' stroke='" + EDGE + "' stroke-width='1.5'/>" + faceOf(code) + "</svg>"
  return (cache[code] = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg))
}

export function renderTile({ code, width = 34, highlight = false, rotated = false, highlightColor = '#e2a93b' }) {
  const h = Math.round(width * 1.4)
  const rad = Math.max(3, Math.round(width * 0.14))
  const shadow = Math.max(1, Math.round(width * 0.07))
  const outlineW = Math.max(2, Math.round(width * 0.09))

  const imgStyle = {
    display: 'block',
    width: width + 'px',
    height: h + 'px',
    borderRadius: rad + 'px',
    background: FACE,
    boxShadow: '0 ' + shadow + 'px 0 rgba(35,44,58,0.28)',
  }
  if (highlight) {
    imgStyle.outline = outlineW + 'px solid ' + highlightColor
    imgStyle.outlineOffset = '1px'
  }
  if (rotated) {
    imgStyle.transform = 'rotate(90deg)'
  }

  const wrapStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: (rotated ? h : width) + 'px',
    height: h + 'px',
  }

  return (
    <span style={wrapStyle}>
      <img src={tileDataURI(code)} alt={code} style={imgStyle} />
    </span>
  )
}

export default renderTile
